const theme = {
    colors: {
        red: '#D72932',
        pink: '#FD89BF',
        lightPink: '#FFD8D8',
        orange: '#FFAA71',
        lightOrange: '#FFE5CF',
        blue: '#4889FA',
        lightBlue: '#D0F5FF',
        green: '#48BA14',
        lightGreen: '#BCEDB9',
        purple: '#A888FF',
        lightPurple: '#f8d2fd',
        // lightPurple: '#FDF0FF',
        darkGray: '#4E4E4E',
        gray: '#c0c0c0',
        lightGray: '#f3f3f3',
        // black : '#202529'
        white: '#fff',
    },
    fontSize: {
        xs: '12px',
        s: '14px',
        m: '16px',
        l: '20px',
        xl: '30px',
    },
    fontWeight: {
        m: 300,
        l: 400,
        xl: 700,
    },
    spacing: {
        xs: '8px',
        s: '16px',
        m: '24px',
        l: '32px',
    },
    borderRadius: { s: '5px', m: '16px', l: '32px' },
    shadow: {
        s: '0 2px 12px 0 #c0c0c0',
        //  m: '',
    },
    avatarSize: {
        xs: '30px',
        s: '50px',
        m: '',
        l: '200px',
    },
    recipeImageSize: {
        s: { width: '', height: '250px' },
        m: { width: '300px', height: '220px' },
        l: { width: '400px', height: '300px' },
    },
};

export default theme;
